import gql from 'graphql-tag';

/** Student facts a school can add to its result PDF, ID card and letters (#574). */
export const GET_STUDENT_DOCUMENT_FIELDS = gql`
  query StudentDocumentFieldList {
    studentDocumentFields { key label }
  }
`;
